// extracted by mini-css-extract-plugin
module.exports = {"button":"compareBtn_button__3cOT-","isItemPage":"compareBtn_isItemPage__Zxsks","iconCompare":"compareBtn_iconCompare__2ezmu"};
    if(module.hot) {
      // 1790670299221
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  